<template>
  <div id="dashboard-content">
    <section v-if="hideForm">
      <div class="alert alert-warning">{{ messageHideForm }}</div>
    </section>
    <section v-else id="profile-publisher">
      <h4 class="mb-4">Buku Teks Pelajaran</h4>
      <div class="card p-3 border-0 shadow-sm mb-3">
        <ul class="nav nav-pills nav-fill" id="pills-tab" role="tablist">
          <li class="nav-item border">
            <a
              class="nav-link active d-flex align-items-center btn-sm"
              id="pills-data-identitas-buku-tab"
              data-toggle="pill"
              href="#pills-data-identitas-buku"
              role="tab"
              aria-controls="pills-data-identitas-buku"
              aria-selected="true"
            >
              <div
                style="width: 25px;height: 25px;"
                class="bg-white text-dark rounded-circle d-flex align-items-center justify-content-center mr-2 border"
              >
                1
              </div>
              Identitas Buku
            </a>
          </li>
          <li class="nav-item pt-1">
            <hr width="50px" />
          </li>
          <li class="nav-item border">
            <a
              class="nav-link d-flex align-items-center btn-sm"
              id="pills-data-pelaku-tab"
              data-toggle="pill"
              href="#pills-data-pelaku"
              role="tab"
              aria-controls="pills-data-pelaku"
              aria-selected="false"
            >
              <div
                style="width: 25px;height: 25px;"
                class="bg-white text-dark rounded-circle d-flex align-items-center justify-content-center mr-2 border"
              >
                2
              </div>
              Data Pelaku Perbukuan
            </a>
          </li>
          <li class="nav-item pt-1">
            <hr width="50px" />
          </li>
          <li class="nav-item border">
            <a
              class="nav-link d-flex align-items-center btn-sm"
              id="pills-data-berkas-buku-tab"
              data-toggle="pill"
              href="#pills-data-berkas-buku"
              role="tab"
              aria-controls="pills-data-berkas-buku"
              aria-selected="false"
            >
              <div
                style="width: 25px;height: 25px;"
                class="bg-white text-dark rounded-circle d-flex align-items-center justify-content-center mr-2 border"
              >
                3
              </div>
              Data Berkas Buku
            </a>
          </li>
          <li class="nav-item pt-1">
            <hr width="50px" />
          </li>
          <li class="nav-item border">
            <a
              class="nav-link d-flex align-items-center btn-sm"
              id="pills-data-berkas-legalitas-tab"
              data-toggle="pill"
              href="#pills-data-berkas-legalitas"
              role="tab"
              aria-controls="pills-data-berkas-legalitas"
              aria-selected="false"
            >
              <div
                style="width: 25px;height: 25px;"
                class="bg-white text-dark rounded-circle d-flex align-items-center justify-content-center mr-2 border"
              >
                4
              </div>
              Data Berkas Legalitas
            </a>
          </li>
        </ul>
      </div>
      <div class="card p-3 border-0 shadow-sm">
        <div v-if="checkStatusProfile" class="alert alert-warning">
          <span>Silakan isi data profile anda terlebih dahulu. </span>
          <router-link to="/user/profil/publisher" class="text-primary">
            <a>Lengkapi profil</a>
          </router-link>
        </div>
        <form v-else @submit.prevent="createAssesment()">
          <div class="tab-content border-0" id="pills-tabContent">
            <div
              class="tab-pane fade show active"
              id="pills-data-identitas-buku"
              role="tabpanel"
              aria-labelledby="pills-data-identitas-buku-tab"
            >
              <h5 class="font-weight-bold mb-2">Identitas Buku</h5>
              <p class="mb-4">Silahkan isi data-data terkait identitas buku</p>

              <!-- Form Input Here -->

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="assesmentEventId" class="form-label">
                      Agenda Penilaian
                    </label>
                    <input
                      readonly
                      v-model="assesmentEvent"
                      id="assesmentEventId"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="assesmentEventId" class="form-label">
                      Tipe Buku
                    </label>
                    <input
                      readonly
                      id="assesmentEventId"
                      value="Buku Teks Pendamping"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="judulBuku" class="form-label">
                      Judul Buku <span class="text-danger">*</span>
                    </label>
                    <input
                      id="judulBuku"
                      type="text"
                      class="form-control"
                      placeholder="Masukkan judul buku"
                      v-model="assesment.title"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="isbn" class="form-label">ISBN</label>
                    <input
                      id="isbn"
                      type="text"
                      class="form-control"
                      placeholder="Masukkan ISBN"
                      v-model="assesment.isbn"
                    />
                    <small>
                      ISBN Wajib dikirimkan setelah buku dinyatakan lolos
                      penilaian.
                    </small>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="tahunTerbit" class="form-label">
                      Tahun Terbit (3 tahun terakhir)
                    </label>
                    <select
                      required
                      v-model="assesment.publication_year"
                      id="tahunTerbit"
                      class="form-control"
                    >
                      <option v-for="(year,index) in publishedYear" :key="index" :value="year">{{year}}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="level" class="form-label">
                      Jenjang <span class="text-danger">*</span></label
                    >
                    <select
                      required
                      v-model="assesment.level"
                      id="jenjang"
                      class="form-control"
                    >
                      <option value="SD">SD/MI</option>
                      <option value="SMP">SMP/MTS</option>
                      <option value="SMA/MA/SMK/MAK">SMA/MA/SMK/MAK</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="semester" class="form-label">
                      Semester <span class="text-danger">*</span></label
                    >
                    <select
                      required
                      v-model="assesment.semester"
                      id="semester"
                      class="form-control"
                    >
                      <option value="1">1</option>
                      <option value="2">2</option>
                      <option value="1 dan 2">1 dan 2</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="subject" class="form-label">
                      Mata Pelajaran <span class="text-danger">*</span>
                    </label>
                    <select
                      required
                      v-model="assesment.subject"
                      id="subject"
                      class="form-control"
                    >
                      <option v-for="(subject, index) in subjects_school" :value="subject" :key="index">
                        {{ subject }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="imprint" class="form-label">Imprint</label>
                    <input
                      id="imprint"
                      type="text"
                      class="form-control"
                      placeholder="Masukkan nama dagang"
                      v-model="assesment.imprint"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="edition" class="form-label">Edisi Ke-</label>
                    <input
                      id="edition"
                      type="number"
                      min="1"
                      class="form-control"
                      placeholder="Masukkan edisi"
                      v-model="assesment.edition"
                    />
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="jumlahHalPrelim" class="form-label">
                      Jumlah Hal Preliminer <span class="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      min="1"
                      id="jumlahHalPrelim"
                      class="form-control"
                      v-model="assesment.total_prelim_page"
                      placeholder="Masukkan jumlah halaman prelim"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="jumlahHalIsi" class="form-label">
                      Jumlah Hal Isi <span class="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      min="1"
                      id="jumlahHalIsi"
                      class="form-control"
                      v-model="assesment.total_content_page"
                      placeholder="Masukkan jumlah halaman isi"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="jumlahHalPostlim" class="form-label">
                      Jumlah Hal Posliminer <span class="text-danger">*</span>
                    </label>
                    <input
                      type="number"
                      min="1"
                      id="jumlahHalPostlim"
                      class="form-control"
                      v-model="assesment.total_ending_page"
                      placeholder="Masukkan jumlah halaman postlim"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="sinopsis" class="form-label">
                      Sinopsis (blurb) <span class="text-danger">*</span>
                    </label>
                    <textarea
                      id="sinopsis"
                      rows="5"
                      class="form-control"
                      placeholder="Masukkan sinopsis"
                      v-model="assesment.synopsis"
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- Form Input Here -->

              <div class="d-flex justify-content-end mt-4" role="tablist">
                <button
                  type="button"
                  class="btn rounded-pill btn-secondary text-white"
                  @click="selectTab('#pills-data-pelaku-tab')"
                >
                  Selanjutnya
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="pills-data-pelaku"
              role="tabpanel"
              aria-labelledby="pills-data-pelaku-tab"
            >
              <h5 class="font-weight-bold mb-2">Data Pelaku Perbukuan</h5>
              <p class="mb-4">
                Silahkan isi data-data terkait pelaku perbukuan
              </p>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="penulis" class="form-label">
                      Nama Penulis <span class="text-danger">*</span>
                    </label>
                    <input
                      id="penulis"
                      type="text"
                      class="form-control"
                      placeholder="Masukkan nama penulis"
                      v-model="assesment.author"
                    />
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="editor" class="form-label">
                      Nama Editor <span class="text-danger">*</span>
                    </label>
                    <input
                      id="editor"
                      type="text"
                      class="form-control"
                      placeholder="Masukkan nama editor"
                      v-model="assesment.editor"
                    />
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label for="ilustrator" class="form-label"
                      >Nama Ilustrator</label
                    >
                    <input
                      id="ilustrator"
                      type="text"
                      class="form-control"
                      placeholder="Masukkan nama ilustrator"
                      v-model="assesment.illustrator"
                    />
                  </div>
                </div>
              </div>

              <div class="d-flex justify-content-end mt-4" role="tablist">
                <button
                  type="button"
                  class="btn rounded-pill btn-outline-secondary mr-3"
                  @click="selectTab('#pills-data-identitas-buku-tab')"
                >
                  <i class="fa fa-chevron-left"></i>
                  Sebelumnya
                </button>
                <button
                  type="button"
                  class="btn rounded-pill btn-secondary text-white"
                  @click="selectTab('#pills-data-berkas-buku-tab')"
                >
                  Selanjutnya
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="pills-data-berkas-buku"
              role="tabpanel"
            >
              <h5 class="font-weight-bold mb-2">Data Berkas Buku</h5>
              <p class="mb-4">Silahkan isi data-data terkait berkas buku</p>

              <!-- Form Input Here -->
              <div class="row d-flex align-items-center">
                <div class="col-12 mb-4">
                  <div class="form-group">
                    <label for="fileOriginal" class="form-label">
                      Berkas PDF Orisinal dan Lengkap
                      <span class="text-danger">*</span>
                    </label>
                    <FileUploader
                      @select-file="setFile($event, 'file_original')"
                      :uploaded="assesment.file_original"
                      id="file_original"
                    />
                    <div class="text-muted text-right small mt-2">
                      Format PDF, Ukuran Maks 50 Mb
                    </div>
                  </div>
                  <div class="my-1">
                    <button
                      v-if="!loading.file_original"
                      @click="uploadFile('file_original')"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                      id="uploadFileOriginal"
                    >
                      Unggah
                    </button>
                    <button
                      v-if="loading.file_original"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                    >
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                    <button
                      v-else-if="
                        !loading.file_original &&
                          link.file_original
                      "
                      type="button"
                      class="btn btn-secondary btn-sm mt-1"
                      disabled
                    >
                      Berhasil Diunggah <i class="fas fa-check"></i>
                    </button>
                  </div>
                </div>
                <div class="col-12 mb-4">
                  <div class="form-group">
                    <label for="fileNoIdentity" class="form-label">
                      Berkas PDF Tanpa Identitas
                      <span class="text-danger">*</span>
                    </label>
                    <FileUploader
                      @select-file="setFile($event, 'file_no_identity')"
                      :uploaded="assesment.file_no_identity"
                      id="file_no_identity"
                    />
                    <div class="text-muted text-right small mt-2">
                      Format PDF, Ukuran Maks 50 Mb
                    </div>
                  </div>
                  <div class="my-1">
                    <button
                      v-if="!loading.file_no_identity"
                      @click="uploadFile('file_no_identity')"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                      id="uploadFileNoIdentity"
                    >
                      Unggah
                    </button>
                    <button
                      v-if="loading.file_no_identity"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                    >
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                    <button
                      v-else-if="
                        !loading.file_no_identity && link.file_no_identity
                      "
                      type="button"
                      class="btn btn-secondary btn-sm mt-1"
                      disabled
                    >
                      Berhasil Diunggah <i class="fas fa-check"></i>
                    </button>
                  </div>
                </div>
                <div class="col-12 mb-4">
                  <div class="form-group">
                    <label for="fileTurnitin" class="form-label">
                      Berkas PDF Hasil Uji Kemiripan
                      <span class="text-danger">*</span>
                    </label>
                    <FileUploader
                      @select-file="
                        setFile($event, 'file_turnitin')
                      "
                      :uploaded="assesment.file_turnitin"
                      id="file_turnitin"
                    />
                    <div class="text-muted text-right small mt-2">
                      Format PDF, Ukuran Maks 50 Mb
                    </div>
                  </div>
                  <div class="my-1">
                    <button
                      v-if="!loading.file_turnitin"
                      @click="uploadFile('file_turnitin')"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                      id="uploadTurnitin"
                    >
                      Unggah
                    </button>
                    <button
                      v-if="loading.file_turnitin"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                    >
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                    <button
                      v-else-if="
                        !loading.file_turnitin &&
                          link.file_turnitin
                      "
                      type="button"
                      class="btn btn-secondary btn-sm mt-1"
                      disabled
                    >
                      Berhasil Diunggah <i class="fas fa-check"></i>
                    </button>
                  </div>
                </div>
                <div class="col-12 mb-4">
                  <div class="form-group">
                    <label for="fileCapaianPembelajaran" class="form-label">
                      Berkas PDF Capaian Pembelajaran
                      <span class="text-danger">*</span>
                    </label>
                    <FileUploader
                      @select-file="
                        setFile($event, 'file_capaian_pembelajaran')
                      "
                      :uploaded="assesment.file_capaian_pembelajaran"
                      id="file_capaian_pembelajaran"
                    />
                    <div class="text-muted text-right small mt-2">
                      Format PDF, Ukuran Maks 5 Mb
                    </div>
                  </div>
                  <div class="my-1">
                    <button
                      v-if="!loading.file_capaian_pembelajaran"
                      @click="uploadFile('file_capaian_pembelajaran')"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                      id="uploadFileCapaianPembelajaran"
                    >
                      Unggah
                    </button>
                    <button
                      v-if="loading.file_capaian_pembelajaran"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                    >
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                    <button
                      v-else-if="
                        !loading.file_capaian_pembelajaran &&
                          link.file_capaian_pembelajaran
                      "
                      type="button"
                      class="btn btn-secondary btn-sm mt-1"
                      disabled
                    >
                      Berhasil Diunggah <i class="fas fa-check"></i>
                    </button>
                  </div>
                </div>
                <div v-show="isShowMatrix" class="col-12 mb-4">
                  <div class="form-group">
                    <label for="fileMatrixPerbaikan" class="form-label">
                      Berkas PDF Matrix Perbaikan
                      <span class="text-danger">*</span>
                    </label>
                    <FileUploader
                      @select-file="setFile($event, 'file_matrix_perbaikan')"
                      :uploaded="assesment.file_matrix_perbaikan"
                      id="file_matrix_perbaikan"
                    />
                    <div class="text-muted d-flex small mt-2">
                      <div class="mr-auto">
                        Link contoh matrix perbaikan
                        <a
                          href="https://docs.google.com/spreadsheets/d/1K3LTA32IBVLgvbmEw18XYSfeg5pB5DEM6ZBxRAjPa0g/edit#gid=0"
                          target="_blank"
                        >
                          https://s.id/templateMatriksPerbaikan
                        </a>
                      </div>
                      <div>Format PDF, Ukuran Maks 5 Mb</div>
                    </div>
                  </div>
                  <div class="my-1">
                    <button
                      v-if="!loading.file_matrix_perbaikan"
                      @click="uploadFile('file_matrix_perbaikan')"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                      id="uploadFileMatrixPerbaikan"
                    >
                      Unggah
                    </button>
                    <button
                      v-if="loading.file_matrix_perbaikan"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                    >
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                    <button
                      v-else-if="
                        !loading.file_matrix_perbaikan &&
                          link.file_matrix_perbaikan
                      "
                      type="button"
                      class="btn btn-secondary btn-sm mt-1"
                      disabled
                    >
                      Berhasil Diunggah <i class="fas fa-check"></i>
                    </button>
                  </div>
                </div>
              </div>
              <!-- Form Input Here -->

              <div class="d-flex justify-content-end mt-4" role="tablist">
                <button
                  type="button"
                  class="btn rounded-pill btn-outline-secondary mr-3"
                  @click="selectTab('#pills-data-pelaku-tab')"
                >
                  <i class="fa fa-chevron-left"></i>
                  Sebelumnya
                </button>
                <button
                  type="button"
                  class="btn rounded-pill btn-secondary text-white"
                  @click="selectTab('#pills-data-berkas-legalitas-tab')"
                >
                  Selanjutnya
                  <i class="fa fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div
              class="tab-pane fade"
              id="pills-data-berkas-legalitas"
              role="tabpanel"
            >
              <h5 class="font-weight-bold mb-2">Data Berkas Legalitas</h5>
              <p class="mb-4">
                Silahkan isi data-data terkait berkas legalitas
              </p>

              <!-- Form Input Here -->
              <div class="row d-flex align-items-center">
                <div class="col-12 mb-4">
                  <div class="form-group">
                    <label for="suratPernyataanPenulis" class="form-label">
                      Surat pernyataan penerbit tentang hak terbit dan keaslian
                      naskah
                      <span class="text-danger">*</span>
                    </label>
                    <FileUploader
                      @select-file="setFile($event, 'surat_pernyataan_penulis')"
                      :uploaded="assesment.surat_pernyataan_penulis"
                      id="surat_pernyataan_penulis"
                    />
                    <div class="text-muted d-flex small mt-2">
                      <div class="mr-auto">
                        Download contoh surat pernyataan penerbit
                        <a
                          href="https://docs.google.com/document/d/1nnRU4Fko0pBbVjYMLo_0_AhFRsPByxlA/edit?usp=sharing&ouid=114512911415227814558&rtpof=true&sd=true"
                          target="_blank"
                        >
                          <i class="fa fa-download text-primary ml-2"></i>
                        </a>
                      </div>
                      <div>Format PDF, Ukuran Maks 2 Mb</div>
                    </div>
                  </div>
                  <div class="my-1">
                    <button
                      v-if="!loading.surat_pernyataan_penulis"
                      @click="uploadFile('surat_pernyataan_penulis')"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                      id="uploadFileSuratPernyataanPenulis"
                    >
                      Unggah
                    </button>
                    <button
                      v-if="loading.surat_pernyataan_penulis"
                      type="button"
                      class="btn btn-primary w-100 btn-sm"
                    >
                      <div
                        class="spinner-border spinner-border-sm"
                        role="status"
                      >
                        <span class="sr-only">Loading...</span>
                      </div>
                    </button>
                    <button
                      v-else-if="
                        !loading.surat_pernyataan_penulis &&
                          link.surat_pernyataan_penulis
                      "
                      type="button"
                      class="btn btn-secondary btn-sm mt-1"
                      disabled
                    >
                      Berhasil Diunggah <i class="fas fa-check"></i>
                    </button>
                  </div>
                </div>
                <div class="col-12 mb-3">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      @change="!assesment.accept_tnc"
                      v-model="assesment.accept_tnc"
                      type="checkbox"
                      id="accept"
                    />
                    <label class="form-check-label" for="accept">
                      Dengan ini saya menyatakan bahwa data di atas adalah
                      benar. <span class="text-danger">*</span>
                    </label>
                  </div>
                </div>
              </div>
              <!-- Form Input Here -->

              <div
                v-if="$store.state.messageStatusPublisher"
                class="alert alert-success"
              >
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                  @click="$store.state.messageStatusPublisher = false"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
                <span>
                  Terimakasih! Data berhasil diperbaharui. Untuk tahap
                  selanjutnya silahkan akses menu daftarkan buku atau izin
                  cetak.
                </span>
              </div>
              <div class="d-flex justify-content-end mt-4" role="tablist">
                <button
                  type="button"
                  class="btn rounded-pill btn-outline-secondary mr-3"
                  @click="selectTab('#pills-data-berkas-buku-tab')"
                >
                  <i class="fa fa-chevron-left"></i>
                  Sebelumnya
                </button>
                
                <div class="text-right">
                  <!-- <button
                    type="submit"
                    @click="assesment.status = 'draft'"
                    class="btn btn-secondary px-3"
                  >
                    {{
                      $store.state.loadSubmitAssesment
                        ? "Sedang diproses.."
                        : "Simpan sebagai draf"
                    }}
                  </button> -->
                  <button
                    type="submit"
                    @click="assesment.status = 'publish'"
                    class="btn btn-primary mx-3"
                  >
                    {{
                      $store.state.loadSubmitAssesment
                        ? "Sedang diproses.."
                        : "Simpan permanen"
                    }}
                  </button>
                </div>
              </div>
              <div v-if="assesment.status == 'draft'" class="text-right mx-3 mt-2">
                <small>* Simpan permanen apabila data buku siap untuk dinilai</small>
              </div>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Swal from "sweetalert2";
import FileUploader from "@/components/global/dashboard/FileUploader.vue";
// import { SUBJECT_SMK, SUBJECT_BTP } from "@/constants/subject"

export default {
  data() {
    return {
      hideForm: false,
      messageHideForm: "",
      id: this.$route.query.id ?? null,
      checkStatusProfile: false,
      subjects_school: [],
      isShowMatrix: false,
      publishedYear: [],
      assesment: {
        status: "draft",
        assessment_event_id: this.$route.query.event_id ?? "",
        title: "",
        book_type: "btp",
        subject: "Bahasa Indonesia Kelas III",
        isbn: "",
        publication_year: "",
        level: "SD",
        semester: "1",
        imprint: "",
        edition: "",
        total_prelim_page: "",
        total_content_page: "",
        total_ending_page: "",
        synopsis: "",
        author: "",
        editor: "",
        illustrator: "",
        file_original: "",
        file_no_identity: "",
        file_capaian_pembelajaran: "",
        file_turnitin: "",
        file_matrix_perbaikan: "",
        surat_pernyataan_penulis: "",
        accept_tnc: false,
      },
      file: {
        file_original: null,
        file_no_identity: null,
        file_capaian_pembelajaran: null,
        file_turnitin: null,
        file_matrix_perbaikan: null,
        surat_pernyataan_penulis: null,
      },
      loading: {
        file_original: false,
        file_no_identity: false,
        file_capaian_pembelajaran: false,
        file_turnitin: false,
        file_matrix_perbaikan: false,
        surat_pernyataan_penulis: false,
      },
      link: {
        file_original: "",
        file_no_identity: "",
        file_capaian_pembelajaran: "",
        file_turnitin: "",
        file_matrix_perbaikan: "",
        surat_pernyataan_penulis: "",
      },
      required: [
        {
          title: "berkas legalitas",
          tabs: "#pills-data-berkas-legalitas-tab",
          type: "file",
          input: ["surat_pernyataan_penulis"],
        },
        {
          title: "berkas buku",
          tabs: "#pills-data-berkas-buku-tab",
          type: "file",
          input: [
            "file_original",
            "file_no_identity",
            "file_capaian_pembelajaran",
            "file_turnitin",
          ],
        },
        {
          title: "pelaku perbukuan",
          tabs: "#pills-data-pelaku-tab",
          type: "text",
          input: ["author", "editor"],
        },
        {
          title: "identitas buku",
          tabs: "#pills-data-identitas-buku-tab",
          type: "text",
          input: [
            "title",
            "total_prelim_page",
            "total_content_page",
            "total_ending_page",
            "synopsis",
          ],
        },
      ],
      title: "",
      passedValidation: false,
    };
  },
  computed: {
    ...mapState(["eventPenilaian", "subjects"]),
    assesmentEvent() {
      // Check if there is no data from fetch book detail publisher
      let eventId = this.id
        ? this.assesment.assessment_event_id
        : this.$route.query.event_id;
      let result = this.eventPenilaian?.find((event) => event.id == eventId)
        ?.title;
      return result;
    },
  },
  methods: {
    ...mapActions([
      "submitAssesment",
      "uploadFileAssesment",
      "fetchBookByPublisher",
      "fetchAllEventPenilaian",
      "fetchAllSubject",
      "fetchPublisherProfile",
    ]),
    async checkValidation() {
      let validationFailed = false;

      // Check if revision mode allow validation file matrix perbaikan input
      if (this.isShowMatrix) {
        this.required[1].input.push("file_matrix_perbaikan");
      }

      // Check if event_id 57 file CP is not required
      if (this.assesment.assessment_event_id == 57) {
        this.required[1].input = this.required[1].input.filter(
          (item) => item !== "file_capaian_pembelajaran"
        );
      }

      await Promise.all(
        this.required.map(async (data) => {
          await Promise.all(
            data.input.map(async (name) => {
              if (this.assesment[name] == "") {
                await Swal.fire({
                  icon: "warning",
                  title: `Silahkan lengkapi bagian ${data.title} yang wajib`,
                }).then((status) => {
                  if (status.isConfirmed) {
                    document.querySelector(data.tabs).click();
                    validationFailed = true;
                  }
                });
              } else {
                if (data.type == "file") {
                  if (this.assesment[name] !== this.link[name]) {
                    await Swal.fire({
                      icon: "warning",
                      title: `Silahkan klik tombol unggah pada ${data.title} terlebih dahulu`,
                    }).then((status) => {
                      if (status.isConfirmed) {
                        document.querySelector(data.tabs).click();
                        validationFailed = true;
                      }
                    });
                  }
                }
              }
            })
          );
        })
      );
      // Memanggil metode lain setelah selesai looping data.input.map dan index melewati panjang this.required
      if (!validationFailed) {
        if (!this.assesment.accept_tnc) {
          await Swal.fire({
            icon: "warning",
            title: "Mohon ceklis untuk menyutujui persyaratan dibawah ini",
          });
        } else {
          this.passedValidation = true;
        }
      }
    },
    setTemporarySave(e) {
      const judul = e.target.id == "judulBuku" && e.target.value;
      let data = {
        judulBuku: judul,
      };
      setTimeout(() => {
        localStorage.setItem("data-input", JSON.stringify(data));
      }, 2000);
    },
    selectTab(id) {
      document.querySelector(id).click();
    },
    setFile(file, state) {
      this.file[state] = file;
    },
    uploadFile(state) {
      let file = null;
      // Validation check if file null
      if (this.file[state] !== null) {
        this.loading[state] = true;
        file = this.file[state];
      } else {
        switch (state) {
          case "file_original":
            this.title = "Original Buku";
            break;
          case "file_no_identity":
            this.title = "Tanpa Identitas Buku";
            break;
          case "surat_pernyataan_penulis":
            this.title = "Surat Pernyataan Penerbit";
            break;
          case "file_capaian_pembelajaran":
            this.title = "Capaian Pembelajaran";
            break;
          case "file_turnitin":
            this.title = "Hasil Uji Kemiripan";
            break;
          case "file_matrix_perbaikan":
            this.title = "Matrix Perbaikan";
            break;
          default:
            break;
        }
        Swal.fire({
          icon: "warning",
          title: `Berkas ${this.title} harus diisi`,
        });
      }
      // Upload file to server
      if (file !== null) {
        this.uploadFileAssesment({
          file,
          eventId: parseInt(this.assesment.assessment_event_id),
          field: event.target.id,
        })
          .then((res) => {
            if (res.status == "success") {
              Swal.fire({
                icon: "success",
                title: "Berhasil diunggah, silahkan isi data selanjutnya",
              });
              this.assesment[state] = res.file;
              this.link[state] = res.file;
              this.loading[state] = true;
              this.validation[state] = false;
            } else {
              Swal.fire({
                icon: "warning",
                title: res.message,
              });
            }
          })
          .catch((err) => {
            if (err == 403) {
              Swal.fire({
                icon: "warning",
                title: `Ukuran berkas pada ${this.title} terlalu besar`,
              });
            }
          })
          .finally(() => {
            this.loading[state] = false;
          });
      }
    },
    async createAssesment() {
      await this.checkValidation();
      if (this.passedValidation) {
        this.id != null && (this.assesment["id"] = this.id);
        this.assesment["type_request"] = this.id == null ? "post" : "put";
        await Swal.fire({
          title: "Perhatian",
          icon: "warning",
          text: "Pastikan Bapak/Ibu mengklik tombol unggah berkas terlebih dahulu untuk menyetorkan berkas buku, sebelum mengklik tombol simpan",
          showCancelButton: true,
          confirmButtonText: "Sudah, lanjutkan kirim data saya",
          cancelButtonText: "Ok, saya cek kembali",
        }).then((result) => {
          if (result.isConfirmed) {
            this.submitAssesment(this.assesment).then((res) => {
              if (res.data.status == "success") {
                this.$store.state.messageStatusAssesment = false;
                this.$store.state.loadSubmitAssesment = false;
                
                if(this.id) {
                  this.$router.push({ path: `/user/penilaian/revisi/${this.id}` });
                } else {
                  this.$router.push({ path: `/user/penilaian/detail/${res.data.result.id}` });
                }

              } else {
                Swal.fire({
                  icon: "error",
                  title: "Terjadi kesalahan",
                });
              }
            });
          }
        });
      }
    },
  },
  created() {
    this.assesment.book_type = "btp";

    this.fetchAllEventPenilaian().then((responseEvent) => {
      let checkEvent = responseEvent.data.find((event) => event.id == this.assesment.assessment_event_id);

      if (!checkEvent && !this.id) {
        this.messageHideForm = "Agenda tidak tersedia";
        this.hideForm = true;
        return;
      }

      if (checkEvent?.slug !== "btp") {
        this.messageHideForm = this.id ? 'Buku tidak ditemukan' : 'Agenda tidak tersedia';
        this.hideForm = true;
        return;
      }

      // Set subject from API field subject_class
      this.subjects_school = checkEvent?.subject_class ? checkEvent?.subject_class.split('\r\n') : ['Pilih Mata Pelajaran']
      this.assesment.subject = this.subjects_school[0]

      if (this.id) {
        this.fetchBookByPublisher(this.id)
        .then((res) => {
            if (res.data.length !== 0) {
              let data = res.data;

              // Insert response data to assesment state
              this.assesment = {
                ...this.assesment,
                ...data,
                accept_tnc: data.accept_tnc ? true : false,
              }

              // Remove event_status from object assesment
              delete this.assesment.event_status

              // Insert link to link state for show file if uploaded
              this.link = {
                ...this.link,
                file_original: data.file_original,
                file_no_identity: data.file_no_identity,
                file_capaian_pembelajaran: data.file_capaian_pembelajaran,
                file_turnitin: data.file_turnitin,
                file_matrix_perbaikan: data.file_matrix_perbaikan,
                surat_pernyataan_penulis: data.surat_pernyataan_penulis
              };

              // Logic hide form for revision
              let step = data.step;
              let status = data.status;
              let allowedRevision =
                (step == "Submission" && status == "Menunggu") ||
                (step == "Submission" && status == "Lengkap tapi Tidak Valid") ||
                (step == "Submission" && status == "Perlu Revisi") ||
                (step == "Prapenilaian" && status == "Layak dengan Perbaikan") ||
                (step == "Pleno" && status == "Revisi Minor") ||
                (step == "Pleno Revisi" && status == "Menunggu");
                (step == "Pleno Revisi" && status == "Perlu Revisi");

              // Logic show repair matrix input form 
              if (step == "Pleno Revisi" && status == "Perlu Revisi") {
                this.isShowMatrix = true;
              }

              if (checkEvent?.submit_revision == "0" || checkEvent?.status == 'done') {
                this.messageHideForm = "Data buku sudah tidak dapat diperbaharui";
                this.hideForm = true;
                return;
              } else if (!allowedRevision && data.locked == "1") {
                this.messageHideForm = "Buku sedang dalam proses penilaian dan sementara tidak dapat diperbaharui";
                this.hideForm = true;
                return;
              }

            } else {
              this.messageHideForm = "Buku tidak ditemukan";
              this.hideForm = true;
              return;
            }
          })
          .catch(() => {
            this.messageHideForm = "Buku tidak dapat diakses";
            this.hideForm = true;
          });
      } else {
        if (checkEvent?.status != 'open') {
          this.messageHideForm = "Pendaftaran buku ditutup"; 
          this.hideForm = true;
        } 
      }
    })

    // Dynamic year, from current year to 2 years ago
    const currentYear = new Date().getFullYear();
    this.publishedYear = [currentYear - 2, currentYear - 1, currentYear];
    this.assesment.publication_year = this.publishedYear[2];

    // Check data profile jika belum diisi
    this.fetchPublisherProfile().then((res) => {
      if (!res?.siup) {
        this.checkStatusProfile = true;
      }
    });

  },
  beforeRouteEnter(_, __, next) {
    const { role_name } = JSON.parse(localStorage.getItem("user"));
    if (role_name === "Penerbit") next();
    else next("/user/home");
  },
  components: { FileUploader },
};
</script>

<style></style>